// extracted by mini-css-extract-plugin
module.exports = {"title":"room_title_title__10cTL"};